export default __webpack_public_path__ + "locales/ko-KR/SendInviteDialog.json?hash=00b20134d9fe960da3c31a2c41ed4b97";